<template>
    <div class="home">
        <b-img src="images/bild.png" fluid />
        <span v-html="$t('presentation.auction')" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'auktionen',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>